import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-step-preview',
    standalone: false,
    templateUrl: './step-preview.component.html',
    styleUrl: './step-preview.component.scss'
})
export class StepPreviewComponent implements OnInit {
    data = inject(MAT_DIALOG_DATA);
    dia = inject(MatDialogRef<StepPreviewComponent>)
    private destroyRef = inject(DestroyRef);

    skipDialog: boolean = false;

    ngOnInit(): void {
        this.dia.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: event => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.close();
                    }
                },
            });
    }

    close() {
        this.dia.close(this.skipDialog);
    }
}

